export default{
    lista:{
        method:'get',
        url:'folhar/aplicativo/lista'
    },
    pesquisa:{
        method:'post',
        url:'folhar/aplicativo/busca'
    },
    cadastra:{
        method:'post',
        url:'folhar/aplicativo/cadastro'
    },
    delete:{
        method:'delete',
        url:'folhar/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'folhar/editar{/id}'
    },
    update:{
        method:'post',
        url:'folhar/update'
    },
    pesquisatrabalhador:{
        method:'get',
        url:'aplicativo/trabalhador/pesquisa?folhar_id={folhar_id}&?search={search}'
    },
    servicogeral:{
        method:'post',
        url:'boletins/tabela/geral'
    },
    basecalculo:{
        method:'post',
        url:'basecalculo/cadastro'
    },
    valorcalculo:{
        method:'post',
        url:'boletins/tabela/rublicas'
    },
    valorcalculocadastro:{
        method:'post',
        url:'valorcalculo/cadastro'
    },
    valorcalculogeral:{
        method:'post',
        url:'boletins/tabela/rublicas/geral'
    },
    comissionador:{
        method:'get',
        url:'comissionado/busca{/trabalhador}{/tomador}'
    },
    dias:{
        method:'post',
        url:'relacaodia/busca'
    },
    diascadastro:{
        method:'post',
        url:'relacaodia/cadastro'
    },
    quinzena:{
        method:'post',
        url:'folhar/primeira/quinzena'
    },
}

